export enum TrustInventoryStatusEnum {
  DRAFT = '1',
  PENDING_CONFIRMATION = '2',
  AWAITING_FIRST_APPROVAL = '3',
  AWAITING_FINAL_APPROVAL = '4',
  APPROVED = '5',
}
export const TrustInventoryStatus = [
  { label: '入力中', value: TrustInventoryStatusEnum.DRAFT },
  { label: '確定待ち', value: TrustInventoryStatusEnum.PENDING_CONFIRMATION },
  { label: '第1承認待ち', value: TrustInventoryStatusEnum.AWAITING_FIRST_APPROVAL },
  { label: '最終承認待ち', value: TrustInventoryStatusEnum.AWAITING_FINAL_APPROVAL },
  { label: '承認済み', value: TrustInventoryStatusEnum.APPROVED },
];
